import { z } from 'zod';
import { AdBanner, Article, Competition } from './content.js';
import { Page, ProviderSummary } from './directory.js';
/**
 * The member home feed (D31): approved providers and their work photos, with
 * the competition, sponsored placements and articles mixed in.
 *
 * A discriminated union on `kind`, so a screen switches once and TypeScript
 * knows what it has. The alternative, optional fields on one shape, means
 * every renderer re-checks which ones are set and an impossible combination
 * is only a bug away.
 */
export const FEED_ITEM_KINDS = ['provider', 'competition', 'sponsored', 'article'];
export const ProviderFeedItem = z.object({
    kind: z.literal('provider'),
    provider: ProviderSummary,
    /** The provider's own words about the work shown. Two lines, then "more". */
    caption: z.string().max(2000).nullable(),
});
export const CompetitionFeedItem = z.object({
    kind: z.literal('competition'),
    competition: Competition,
});
export const SponsoredFeedItem = z.object({
    kind: z.literal('sponsored'),
    banner: AdBanner,
});
export const ArticleFeedItem = z.object({
    kind: z.literal('article'),
    article: Article,
});
export const FeedItem = z.discriminatedUnion('kind', [
    ProviderFeedItem,
    CompetitionFeedItem,
    SponsoredFeedItem,
    ArticleFeedItem,
]);
/**
 * A page of the feed, plus where the ordering has reached.
 *
 * The feed runs the member's own area first, then nearby areas, then the
 * newest approved providers. `exhaustedArea` is what the end-of-feed state
 * names ("You've seen everyone in Benoni"), and `nearbyAreas` is what it
 * offers next, so the screen does not have to work either out.
 */
export const FeedPage = Page(FeedItem).extend({
    exhaustedArea: z.string().nullable(),
    nearbyAreas: z.array(z.object({ slug: z.string(), name: z.string() })).max(10),
});
//# sourceMappingURL=feed.js.map